<template>
  <div class="container">
    <div class="board share">
        <div class="qrcode">
            <img :src="`${publicPath}/images/qrcode.svg`">
        </div>
        <div class="shares">
            <div class="share_link">
                <a :href="config.shareLinks.twitter" target="_blank"><img :src="`${publicPath}/images/share/twitter.svg`">Twitter</a>
            </div>
            <div class="share_link">
                <a :href="config.shareLinks.facebook" target="_blank"><img :src="`${publicPath}/images/share/facebook.svg`">Facebook</a>
            </div>
        </div>
        <div class="buttons">
            <a class="button blue" @click="close">CLOSE</a>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareComponent',
  methods: {
    close: function() {
      this.changeView({
        viewName: 'HomeComponent',
        transitionName: 'top'
      })
    }
  }
}
</script>
